export default __webpack_public_path__ + "static/homerunner-da06bd6a37097d43717c23c99f7112fa.png";